import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { FacebookReactionType } from '@sb-tools/typescript/enums/facebook-reaction-type.enum';
import { FacebookUserReaction } from '../../../core/models/facebook-user-reaction.model';
import { TotalReactionsResponse } from '../../../core/models/total-reactions-response.model';

@Injectable({
    providedIn: 'root',
})
export class ReactionsDataService {
    constructor(private httpClient: HttpClient) {}

    getPaginatedReplyReactions(
        ticketId: number,
        replyId: number,
        reactionType: FacebookReactionType,
        socialMediaSourceId: number,
        take: number,
        skip: number,
    ): Observable<FacebookUserReaction[]> {
        return this.httpClient.get<FacebookUserReaction[]>(
            environment.apiInboxUrl +
                'tickets/' +
                ticketId +
                '/replies/' +
                replyId +
                '/reactions/paging/' +
                reactionType +
                '/?socialMediaSourceId=' +
                socialMediaSourceId +
                '&take=' +
                take +
                '&skip=' +
                skip,
        );
    }

    getPaginatedTicketReactions(
        ticketId: number,
        reactionType: FacebookReactionType,
        socialMediaSourceId: number,
        take: number,
        skip: number,
    ): Observable<FacebookUserReaction[]> {
        return this.httpClient.get<FacebookUserReaction[]>(
            environment.apiInboxUrl +
                'tickets/' +
                ticketId +
                '/reactions/paging/' +
                reactionType +
                '/?socialMediaSourceId=' +
                socialMediaSourceId +
                '&take=' +
                take +
                '&skip=' +
                skip,
        );
    }

    getReplyReactions(
        ticketId: number,
        replyId: number,
        socialMediaSourceId: number,
    ): Observable<TotalReactionsResponse> {
        return this.httpClient.get<TotalReactionsResponse>(
            environment.apiInboxUrl +
                'tickets/' +
                ticketId +
                '/replies/' +
                replyId +
                '/reactions?socialMediaSourceId=' +
                socialMediaSourceId,
        );
    }

    getTicketReactions(ticketId: number, socialMediaSourceId: number): Observable<TotalReactionsResponse> {
        return this.httpClient.get<TotalReactionsResponse>(
            environment.apiInboxUrl + 'tickets/' + ticketId + '/reactions?socialMediaSourceId=' + socialMediaSourceId,
        );
    }
}
